import { render, staticRenderFns } from "./stock-reports.vue?vue&type=template&id=a6f8f180"
import script from "./stock-reports.vue?vue&type=script&lang=js"
export * from "./stock-reports.vue?vue&type=script&lang=js"
import style0 from "./stock-reports.vue?vue&type=style&index=0&id=a6f8f180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports